import { convertPRToPO, createPurchaseRequisition, getPurchaseRequisitionDetails, getPurchaseRequisitionList, getPurchaseRequisitionSequence, updatePurchaseRequisition, updatePurchaseRequisitionStatus } from "../api";


export const getPurchaseRequisitionListReq = async (body) => {
  const response = await getPurchaseRequisitionList(body);
  return response.payload;
};

export const getPurchaseRequisitionDetailsReq = async (id) => {
  const response = await getPurchaseRequisitionDetails(id);
  return response.payload;
};

export const getPurchaseRequisitionSequenceReq = async () => {
  const response = await getPurchaseRequisitionSequence();
  return response.payload;
};

export const createPurchaseRequisitionReq = async (body) => {
  const response = await createPurchaseRequisition(body);
  return response;
};

export const updatePurchaseRequisitionReq = async (body) => {
  const response = await updatePurchaseRequisition(body);
  return response;
};

export const updatePurchaseRequisitionStatusReq = async (body) => {
  const response = await updatePurchaseRequisitionStatus(body);
  return response;
};

export const convertToPurchaseOrderReq = async (body) => {
  const response = await convertPRToPO(body);
  return response;
}